<script context="module">import { ResponsiveVars } from "..";
function spacingPropToCSSVar(builder, prop, varName) {
  if (isFluidProp(prop)) {
    builder.addFluid(varName, prop);
  } else {
    builder.addResponsive(varName, prop, (t) => `var(--twist-core-spacing-${t})`);
  }
}
</script>

<script>import { isFluidProp } from "..";
export let display = "block";
export let height = void 0;
export let width = void 0;
export let margin = void 0;
export let marginY = void 0;
export let marginX = void 0;
export let marginLeft = void 0;
export let marginRight = void 0;
export let marginTop = void 0;
export let marginBottom = void 0;
export let padding = void 0;
export let paddingY = void 0;
export let paddingX = void 0;
export let paddingLeft = void 0;
export let paddingRight = void 0;
export let paddingTop = void 0;
export let paddingBottom = void 0;
let responsiveVars;
let cssVarsStyle;
$: {
  const builder = new ResponsiveVars();
  cssVarsStyle = "";
  builder.addResponsive("display", display);
  cssVarsStyle = cssVarsStyle.concat("display: var(--display);");
  if (height) {
    isFluidProp(height) ? builder.addFluid("height", height) : builder.addResponsive("height", height);
    cssVarsStyle = cssVarsStyle.concat("height: var(--height);");
  }
  if (width) {
    isFluidProp(width) ? builder.addFluid("width", width) : builder.addResponsive("width", width);
    cssVarsStyle = cssVarsStyle.concat("width: var(--width);");
  }
  if (margin) {
    spacingPropToCSSVar(builder, margin, "margin");
    cssVarsStyle = cssVarsStyle.concat("margin: var(--margin);");
  }
  if (marginY) {
    spacingPropToCSSVar(builder, marginY, "margin-y");
    cssVarsStyle = cssVarsStyle.concat("margin-block: var(--margin-y);");
  }
  if (marginX) {
    spacingPropToCSSVar(builder, marginX, "margin-x");
    cssVarsStyle = cssVarsStyle.concat("margin-inline: var(--margin-x);");
  }
  if (marginLeft) {
    spacingPropToCSSVar(builder, marginLeft, "margin-left");
    cssVarsStyle = cssVarsStyle.concat("margin-left: var(--margin-left);");
  }
  if (marginRight) {
    spacingPropToCSSVar(builder, marginRight, "margin-right");
    cssVarsStyle = cssVarsStyle.concat("margin-right: var(--margin-right);");
  }
  if (marginTop) {
    spacingPropToCSSVar(builder, marginTop, "margin-top");
    cssVarsStyle = cssVarsStyle.concat("margin-top: var(--margin-top);");
  }
  if (marginBottom) {
    spacingPropToCSSVar(builder, marginBottom, "margin-bottom");
    cssVarsStyle = cssVarsStyle.concat("margin-bottom: var(--margin-bottom);");
  }
  if (padding) {
    spacingPropToCSSVar(builder, padding, "padding");
    cssVarsStyle = cssVarsStyle.concat("padding: var(--padding);");
  }
  if (paddingY) {
    spacingPropToCSSVar(builder, paddingY, "padding-y");
    cssVarsStyle = cssVarsStyle.concat("padding-block: var(--padding-y);");
  }
  if (paddingX) {
    spacingPropToCSSVar(builder, paddingX, "padding-x");
    cssVarsStyle = cssVarsStyle.concat("padding-inline: var(--padding-x);");
  }
  if (paddingLeft) {
    spacingPropToCSSVar(builder, paddingLeft, "padding-left");
    cssVarsStyle = cssVarsStyle.concat("padding-left: var(--padding-left);");
  }
  if (paddingRight) {
    spacingPropToCSSVar(builder, paddingRight, "padding-right");
    cssVarsStyle = cssVarsStyle.concat("padding-right: var(--padding-right);");
  }
  if (paddingTop) {
    spacingPropToCSSVar(builder, paddingTop, "padding-top");
    cssVarsStyle = cssVarsStyle.concat("padding-top: var(--padding-top);");
  }
  if (paddingBottom) {
    spacingPropToCSSVar(builder, paddingBottom, "padding-bottom");
    cssVarsStyle = cssVarsStyle.concat("padding-bottom: var(--padding-bottom);");
  }
  responsiveVars = builder.toCSS();
}
</script>

<div class={responsiveVars} style={cssVarsStyle}>
  <slot />
</div>
